// src/components/Portfolio/DeficienciesObjects/GreenTeaExtract.js

const LichenD3 = {
  productCode: "SBOVZ-D3",
  productName: "Lichen D3",
  ingredients: "Lichens",
  overview:"Orgavitaz D3 is an innovation of wild cultivation of selective strains of lichen diversity in South India for high Cholecalciferol content. This standardized blend offers combination of food Cholecalciferol and Ergocalciferol along with other co-nutrients of lichens. We have identified three strains of Lichens for high Cholecalciferol content.",
  assay:"Natural Cholecalciferol 0.1 %",
  coNutrients:"Incidental nutrients include Ergocalciferol, Iron and calcium (not a claim), natural dietary fiber.",
  studies:"Comprehensive Stability studies, ongoing studies to understand the medicinal benefits that has been reported in Atharvaveda (1500 B.C.).",
  benefits:"Suitable as a natural cytotoxic and hepatoprotective supplement. Supports as a good longevity vitamer ingredient for absorption of minerals required for bone health, anxiety disorder and immune homeostasis.Vitamin D3 and its analogs have particular advantages for immune homeostasis.",
  functionalUse: {
    main: "💊︎ Capsule, 🍚︎ Foods, 🥛︎ Beverages, 🚰︎ ORS, ⊘ Tablets (sensitive), 🍞︎ Baking,  🧂︎ Seasonings, 🍨︎ ice creams",
    note: "(Note:- heat and light sensitive, prone to oxidative stress)"
  },
  bannerImage: [
    "images/Portfolio/OrgavitazForDeficiencies/Lichen-D3/LichenD3-1.png",
    "images/Portfolio/OrgavitazForDeficiencies/Lichen-D3/LichenD3-2.png",
    "images/Portfolio/OrgavitazForDeficiencies/Lichen-D3/LichenD3-3.png",
    "images/Portfolio/OrgavitazForDeficiencies/Lichen-D3/LichenD3-4.png",
    "images/Portfolio/OrgavitazForDeficiencies/Lichen-D3/LichenD3-5.png",

   


  ],
  certificates: [
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L1.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L2.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L3.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L4.png",
    "images/Portfolio/OrgavitazForDeficiencies/B12-Corrinoids/B12-L6.png",
  ]
};

export default LichenD3;
